// src/components/marketing/PublicLayout.js
// Wraps every public page with the shared nav, footer, and auth state. The nav's
// Login button and the status banners all read from one AuthActionsProvider, so
// sign-in works identically on every page.

import { Outlet } from 'react-router-dom';
import { AuthActionsProvider, AuthStatusBanners } from 'components/auth/AuthActions';
import { FONTS, COLORS } from 'styles/theme';
import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';

export default function PublicLayout() {
  return (
    <AuthActionsProvider>
      <div style={{ fontFamily: FONTS.sans, color: COLORS.dark, background: COLORS.cream }}>
        <SiteNav />
        <AuthStatusBanners />
        <main>
          <Outlet />
        </main>
        <SiteFooter />
      </div>
    </AuthActionsProvider>
  );
}
